import { AkciznaMarkicaKategorijaProzivoda } from "../exciseStamps/exciseStamps.types";

export interface IIskorisceneMarkicePayload {
  robnaMarkaId: 0;
  robnaMarkaNaziv: string;
  duvanskiProizvodVrstaId: number;
  datumProizvodnje: string[];
  objekatId: 0;
  objekatMasinaId: 0;
  ambalaza: number;
  kolicina?: number; // Only for Non-Alkohol types
  isporucenOpsegId: number;
  // Only for Alkohol
  opsegOdIskoriscene: string | null;
  opsegDoIskoriscene: string | null;
}
export interface INeiskorisceneMarkicePayload {
  periodId: number;
  kolicina?: number; // Only for Non-Alkohol types
  isporucenOpsegId: number;
  // Only for Alkohol
  neiskoriscene?: string[] | null;
  opsegOdNeiskoriscene?: string | null;
  opsegDoNeiskoriscene?: string | null;
}

export interface IOsteceneMarkiceSaVidljivomSerijom {
  isporucenOpsegId: number;
  kolicina?: number; // Only for Non Alkohol types
  periodId: number;
  // Only for Alkohol
  ostecene?: string[] | null;
  opsegOdOstecene?: string | null;
  opsegDoOstecene?: string | null;
}

export interface IOsteceneMarkiceSaNevidljivomSerijom {
  kolicina: number;
  zahtevId: number;
  markicaKategorijeVrsteId: number;
  periodId: number;
  tipPakovanjaId: number;
}

export interface IEvidentiranjeMarkicaPayload {
  kategorijaProizvoda: number;
  iskorisceneMarkice: IIskorisceneMarkicePayload[];
  neiskorisceneMarkice: INeiskorisceneMarkicePayload[];
  osteceneMarkiceSaNevidljivomSerijom: IOsteceneMarkiceSaNevidljivomSerijom;
  osteceneMarkiceSaVidljivomSerijom: IOsteceneMarkiceSaVidljivomSerijom;
}

export interface GetListaIskoriscenihAMPayload {
  kategorijaEvidentiranihMarkicaId: number;
  uPrometu: boolean | null;
  brojMarkice: string | null;
  brojZahteva: string | null;
}

export interface StavljanjeMarkicaUPrometPayload {
  // When deleting:
  opsegId?: number | null;
  // When adding:
  iskoriscenOpsegId?: number | null;
  kolicina?: number;
  datumStavljanjaUPromet?: string;
  stavljanjeUPromet?: boolean;
  ambalaza?: number;
}

export interface IPonistiEvidentiraniOpsegPayload {
  kategorijaEvidentiranihMarkicaId: number;
  opsegId: number | null;
}

export interface IOpsegUPrometu {
  opseg: string | null;
  opsegPrometId: number | null;
  datumStavljanjaUPromet: string;
  kolicina: string;
  ambalaza: string | null;
}

export interface KategorijeEvidentiranja {
  id: KategorijaEvidentiraneMarkice;
  name: string;
}

export interface IskoriscenaAM {
  // promet: boolean;
  opsegId: number | null;
  opsegEvidentiranihMarkica: string | null;
  opsegDatumaProizvodnje: string | null;
  markicaKategorijeVrste: string | null;
  lokacija: string | null;
  masina: string | null;
  brend: string | null;
  opseziUPrometuInfo: { opsezi: IOpsegUPrometu[]; kolicina: string } | null;
  kolicinaOstecenihVidljivaSerija: number | null;
  pojedinacniUnos: boolean | null;
  obradjen: boolean;
  datumEvidentiranja: string | null;
  brojZahteva: string | null;
  kolicina: number | null;
  period: string | null;
  markicaKategorijeId: AkciznaMarkicaKategorijaProzivoda | null;
  isPosebniPostupak: boolean | null;
  ambalaza: number | null;
}

export interface ListaIskoriscenihAM {
  kategorijeEvidentiranja: KategorijeEvidentiranja[] | null;
  evidentiraneMarkice: IskoriscenaAM[] | null;
}

export interface IDrustvoAktivniObjektiProps {
  id: number | null;
  naziv: string;
  ulicaIBroj: string;
  masine: { id: number; serijskiBroj: string }[];
}

export interface IDrustvoAktivniObjektiResponse {
  data: IDrustvoAktivniObjektiProps[];
  success: boolean;
  errorMessage: string;
}

export interface IRobneMarkePretragaPayload {
  naziv: string | null;
  vrstaProizvodaId?: number | null;
}

export enum KategorijaEvidentiraneMarkice {
  ISKORISCENE_PROIZVODNJA = 1,
  ISKORISCENE_UVOZ,
  NEISKORISCENE,
  OSTECENE_VIDLJIVE,
  OSTECENE_NEVIDLJIVE,
}
